module.exports = __webpack_public_path__ + "static/assets/0444b22c19f72bce702a015c6ae17bb2.png";